import React from "react";
import { motion } from "framer-motion";

export const PageHero = ({ label, title, intro, image, testId = "page-hero" }) => (
  <section className="relative pt-40 md:pt-48 pb-20 md:pb-28 overflow-hidden" data-testid={testId}>
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-end">
      <div className="lg:col-span-7">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="kept-label brass-text mb-8"
        >
          {label}
        </motion.div>
        <h1
          className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter leading-[1.12] text-kept-ink overflow-hidden"
          style={{ paddingBottom: "0.12em", marginBottom: "-0.12em" }}
        >
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          >
            {title}
          </motion.span>
        </h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="text-muted-foreground mt-8 max-w-xl text-base md:text-lg leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
      </div>
      {image && (
        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3, duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <div className="relative aspect-[4/3] overflow-hidden">
            <img src={image} alt={title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 ring-1 ring-inset ring-kept-ink/10" />
          </div>
        </motion.div>
      )}
    </div>
  </section>
);

export default PageHero;
